import { quickOrder } from './quick-order.i18n';

export const en = {
  quickOrder,
};
